import { atom } from 'recoil';

export const isWebViewState = atom<boolean>({
  key: 'isWebViewState',
  default: false,
});
